import { pixiComponents } from '../fastTradeGameContent/pixiComponent';
import { fastTradeBetStore } from '../fastTradeStore/betStore';
import { worker } from '../../../index';
import { fastTradeCountdownDeductionValues } from '../fastTradeCore/constants';
import { RoundStatus } from '../../../core/constants/roundStatus';
import { DefaultQueryParams } from '../../../core/constants/defaultQueryParams';
import { parseQuery } from '../../../core/helpers/parseQuery';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';
import { userInfoStore } from '../../../store/userInfoStore';
import { notificationStore } from '../../../store/notificationStore';
import { checkHashStore } from '../../../store/checkHashStore';
import { betHistoryStore } from '../../../store/betHistoryStore';
import { getIsDocumentHidden } from '../../../core/helpers/documentVisibility';
// import { applicationStore } from '../../../store/applicationStore';

let intervalId = null;

class FastTradeGameService {
  onGetInitialStateResult(data) {
    const { roundInfo, results } = data;
    // if (roundInfo.second < -3) {
    //   setTimeout(() => {
    //     applicationStore.setIsSocketConnected(false);
    //     mainGameConnection.sendGameGetInitialState(false);
    //   }, 0);
    // }
    this.resetInitState();
    fastTradeBetStore.setGameLatestResults(results);
    const {
      resultHash,
      resultKey,
      resultSalt,
      roundId,
      roundData,
      startedDate: lastStartedDate,
    } = results.filter((item) => item.status === RoundStatus.finished)?.[0] || '';
    checkHashStore.setNextRoundHash(
      results.filter((item) => item.status === RoundStatus.started)?.[0]?.resultHash || ''
    );
    checkHashStore.setLastRoundInfo({
      salt: resultSalt,
      hash: resultHash,
      key: resultKey,
      roundId,
      roundData,
      startedDate: lastStartedDate,
    });
    if (roundInfo) {
      const { second, duration } = roundInfo;
      fastTradeBetStore.setDecisionDuration(duration - 1);
      if (second > 0) {
        pixiComponents.PixiComponent.chart.betBlocks.setRoundInfo({
          roundId: roundInfo.roundIds[0],
        });
        fastTradeBetStore.setRoundId(roundInfo.roundIds[0]);
        const timerValue = Math.ceil(Math.abs(second - 1));
        fastTradeBetStore.setTime(timerValue);
        this.sendWorker({ timerValue, ...fastTradeCountdownDeductionValues });
      } else {
        this.sendWorker();
        fastTradeBetStore.setIsBetsClosed(true);
      }
      const allDots = [];
      roundInfo.dots.forEach(({ dots }) => {
        if (dots) {
          dots.forEach((dot) => allDots.push(dot * pixiComponents.PixiComponent.chart.dotGrowth));
        }
      });
      fastTradeBetStore.setBetBlocks(roundInfo.betBlocks);
      pixiComponents.PixiComponent.chart.setDots(allDots);
      pixiComponents.PixiComponent.chart.setCenterDot(allDots[allDots.length - 1], true);
      pixiComponents.PixiComponent.chart.addChartPointerLine(allDots[allDots.length - 1]);
      pixiComponents.PixiComponent.chart.betBlocks.setBetBlocks(roundInfo.betBlocks);
      if (second > 0) {
        pixiComponents.PixiComponent.chart.betBlocks.setIsShow(true);
      }
      const allRoundBets = roundInfo.dots.reduce((acc, cur) => {
        acc[cur.roundId] = cur.bets.reduce((newArr, elem) => {
          newArr = [...newArr, ...elem.additionalParams.markets];
          return newArr;
        }, []);
        return acc;
      }, {});
      pixiComponents.PixiComponent.chart.betBlocks.handleAddHistoryBlocksInitial(
        allRoundBets,
        roundInfo.betBlocks
      );
    }
    pixiComponents.PixiComponent.chart.betBlocks.setActionOddStyles();
  }

  handleRoundStart({
    data: {
      results,
      additionalData,
      startedRound: { roundId },
    },
  }) {
    const {
      resultHash,
      resultKey,
      resultSalt,
      roundData,
      startedDate: lastStartedDate,
      roundId: lastRoundId,
    } = results.filter((item) => item.status === RoundStatus.finished)?.[0] || '';
    checkHashStore.setNextRoundHash(
      results.filter((item) => item.status === RoundStatus.started)?.[0].resultHash
    );
    checkHashStore.setLastRoundInfo({
      salt: resultSalt,
      hash: resultHash,
      key: resultKey,
      roundData,
      roundId: lastRoundId,
      startedDate: lastStartedDate,
    });
    fastTradeBetStore.setBetBlocks(additionalData.betBlocks);
    fastTradeBetStore.updateLatestResults(
      results.filter((item) => item.status === RoundStatus.finished)[0]
    );
    fastTradeBetStore.setRoundId(roundId);
    fastTradeBetStore.setIsBetsClosed(false);
    pixiComponents.PixiComponent.chart.betBlocks.setRoundInfo({
      roundId: roundId,
    });
    pixiComponents.PixiComponent.chart.betBlocks.setBetBlocks(additionalData.betBlocks);
    pixiComponents.PixiComponent.chart.betBlocks.setIsShow(true);
    this.sendWorker({
      timerValue: fastTradeBetStore.decisionDuration,
      ...fastTradeCountdownDeductionValues,
    });
  }

  handleResultReport() {}

  async handleRoundFinished({ data }) {
    fastTradeBetStore.setIsBetsClosed(true);
    pixiComponents.PixiComponent.chart.betBlocks.setIsShow(false);
    const { [DefaultQueryParams.UserId]: userId } = parseQuery(window.location.search);
    const userBets = data.bets.find((item) => +userId === +item.userId);
    pixiComponents.PixiComponent.chart.betBlocks.handleDisableActions();
    pixiComponents.PixiComponent.chart.betBlocks.setHistoryBlocks();
    pixiComponents.PixiComponent.chart.betBlocks.removeBetBlocks();
    pixiComponents.PixiComponent.chart.betBlocks.removeBetModel();
    pixiComponents.PixiComponent.chart.betBlocks.setRoundInfo({
      roundId: data.finishedRound.id,
      resultPoint: data.finishedRound.roundData.resultPoint,
    });
    const newDots = data.finishedRound.roundData.dots;
    setTimeout(() => {
      if (userBets && userBets.additionalParams) {
        pixiComponents.PixiComponent.chart.betBlocks.handleWiningBets(userBets.additionalParams);
      }
      setTimeout(() => {
        userInfoStore.getBalance();
      }, 2000);
    }, 3300);
    setTimeout(() => {
      betHistoryStore.getLastBet();
    }, 5000);
    if (getIsDocumentHidden()) {
      for (let i = 0; i < newDots.length; i += 1) {
        pixiComponents.PixiComponent.chart.betBlocks.moveHistoryContainer(
          pixiComponents.PixiComponent.chart.dotsMargin
        );
        // eslint-disable-next-line no-await-in-loop
        await pixiComponents.PixiComponent.chart.addDot(
          newDots[i] * pixiComponents.PixiComponent.chart.dotGrowth
        );
      }
      setTimeout(() => {
        pixiComponents.PixiComponent.chart.betBlocks.moveHistoryContainerVertical(
          pixiComponents.PixiComponent.chart.centerDot,
          newDots[newDots.length - 1] * pixiComponents.PixiComponent.chart.dotGrowth
        );
        pixiComponents.PixiComponent.chart.moveChartPointers(
          pixiComponents.PixiComponent.chart.centerDot,
          newDots[newDots.length - 1] * pixiComponents.PixiComponent.chart.dotGrowth
        );
        pixiComponents.PixiComponent.chart.setCenterDot(
          newDots[newDots.length - 1] * pixiComponents.PixiComponent.chart.dotGrowth
        );
      }, 500);
    }

    setTimeout(() => {
      pixiComponents.PixiComponent.chart.betBlocks.handleRemoveActionsData();
    }, 2000);
  }

  handleBetsClosed({ data }) {
    const { [DefaultQueryParams.GameId]: gameId, [DefaultQueryParams.PartnerId]: partnerId } =
      parseQuery(window.location.search);
    fastTradeBetStore.setIsBetsClosed(true);
    pixiComponents.PixiComponent.chart.betBlocks.handleDisableActions();
    const sendBetModel = pixiComponents.PixiComponent.chart.betBlocks.betModel.map(
      ({ roundId, amount, marketType, min }) => ({ roundId, amount, marketType, point: min })
    );
    if (sendBetModel.length) {
      mainGameConnection.doBet(
        {
          gameTypeId: data.gameTypeId,
          partnerId,
          gameId,
          betData: sendBetModel,
        },
        false
      );
    }
  }

  handleDoBetResult(data) {
    const { playerExternalId, responseCode } = data;
    const { userId } = userInfoStore;
    if (Number(playerExternalId) === Number(userId)) {
      notificationStore.setNotification(responseCode);
    }
  }

  handleDoBetResultValidation({ responseCode }) {
    pixiComponents.PixiComponent.chart.betBlocks.handleRemoveActionsData();
    pixiComponents.PixiComponent.chart.betBlocks.removeBetModel();
    pixiComponents.PixiComponent.chart.betBlocks.removeBetBlocks();
    notificationStore.setNotification(responseCode);
  }

  countDown({ data }) {
    fastTradeBetStore.setTime(data?.timerValue);
  }

  sendWorker(time) {
    if (time) {
      worker.addEventListener('message', this.countDown);
      worker.postMessage(time);
    } else {
      worker.removeEventListener('message', this.countDown);
    }
  }

  resetInitState() {
    if (intervalId) {
      clearInterval(intervalId);
    }
    intervalId = setInterval(
      () => pixiComponents.PixiComponent.chart.parseGraphicsPointsFromDots(),
      1000 / 30
    );
    pixiComponents.PixiComponent.chart.bgContainer.position.x = 0;
    pixiComponents.PixiComponent.chart.clearAllGsapAnimations();
    pixiComponents.PixiComponent.chart.betBlocks.handleRemoveHistoryBlocks();
    pixiComponents.PixiComponent.chart.handleResetChartPoints();
  }
}

export const fastTradeGameService = new FastTradeGameService();
